import { Button } from "@mui/material";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { FileUpload } from "./file-upload";
import { UploadFileSuccessToast } from "./upload-file-success-toast";

import type { FileUploadProps } from "./file-upload";
import type { Asset } from "./server/digital-asset-service";
import type { FC } from "react";

export const UploadFileModal: FC<
  FileUploadProps & {
    onViewFileClick: (asset: Asset) => void;
  }
> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <FileUpload
      {...props}
      renderActions={({ uploadState, handleSave, handleClose }) => (
        <Button
          disabled={
            !uploadState.fileUrl ||
            !uploadState.fileType ||
            !uploadState.fileTitle ||
            uploadState.showNewFolderField
          }
          loading={loading}
          onClick={() => {
            void (async () => {
              setLoading(true);
              const result = await handleSave();
              result.success && handleClose();
              setLoading(false);
            })();
          }}
          data-analytics-id="upload-file-modal-begin-upload"
          data-testid="upload-modal-button"
        >
          Upload
        </Button>
      )}
      onSuccess={(fileTitle, asset) => {
        props.onViewFileClick(asset);
        toast.custom(
          <UploadFileSuccessToast
            fileTitle={fileTitle}
            onClick={() => {
              if (asset) {
                props.onViewFileClick(asset);
              }
            }}
          />,
        );
      }}
    />
  );
};
